module.exports = __webpack_public_path__ + "media/images/flags/64/China-bb79da95719a37ba81837c0043089280.png";